<template>
  <div>
    <v-layout
      row
      ma-0
      justify-space-between
    >
      <v-img
        class="rounded mr-6 mb-3"
        :src="img"
        aspect-ratio="1"
        max-width="50"
        max-height="50"
        width="50"
        height="50"
      ></v-img>

      <v-layout
        justify-center
        column
      >
        <h4 v-if="title" class="mb-1" v-html="title"></h4>
        <small v-if="address || zip" class="mb-2" v-html="`${address ? address : ''} ${address ? ' - ' + zip : ''}`"></small>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => 'No name'
    },
    img: {
      type: String,
      default: () => `${require('@/assets/images/entreprise.svg')}`
    },
    address: {
      type: String,
      default: () => 'No address'
    },
    zip: {
      type: String,
      default: () => 'No zip code'
    }
  }
}
</script>
